'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var Tabs = require('src/behaviors/tabs')

var DialogModel = require('src/common/dialog-model.js')

var EditNewView = require('./view.js')
var EditNewController = require('src/components/edit_new-controller.js')

var EditNewUser = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      this.region = options.region

      // var tabs = new Tabs.Collection([
      //   (new Tabs.Model({ label: 'Basic', slug: 'basic', elementId: 'tab-basic' })),
      //   (new Tabs.Model({ label: 'Notifications', slug: 'notifications', elementId: 'tab-notifications' }))
      // ])

      var users = options.collection
      var user = options.model

      if (!user) user = App.globalChannel.request('user:entity:new')

      // define the dialog model
      var dialogModel = new DialogModel({
        title: 'user',
        buttons: {
          left: [
            { label: 'delete', icon: true, slug: 'delete', action: 'dialog:delete', roles: ['super', 'admin'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        },
        tabs: [
          { label: 'Basic', slug: 'basic', elementId: 'tab-basic', roles: [] },
          { label: 'Notifications', slug: 'notifications', elementId: 'tab-notifications', roles: [] }
        ]
      })

      // this.view = this.getEditNewView(user, users, tabs)

      // this.listenTo(this.view, 'client-users:delete', this.onDelete)
      // this.listenTo(this.view, 'form:submit', this.formSubmit)

      // load view
      this.view = this.getLayout(dialogModel, user, users)

      // listen
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)
      this.listenTo(this.view, 'childview:send-new-password', this.onSendNewPassword)

      this.region.show(this.view)
    },
    onSendNewPassword: function (args) {
      args.model.resetPassword({
        success: function () {
          App.dialog.notice('New password was sent to ' + args.model.get('email'))
        },
        error: function () {
          App.dialog.alert('Error while resetting password.')
        }
      })
    },
    onDeleteMessage: function (model, message) {
      return 'Are you sure you want to delete the user "' + model.get('email') + '"?'
    },
    formPreSave: function (model, data) {
      var self = this

      if (model.isNew()) data.client = self.options.client.get('_id')

      return data
    },
    getLayout: function (dialogModel, model, collection) {
      return new EditNewView.layout({
        dialogModel: dialogModel,
        model: model,
        collection: collection
      })
    }
  })

  return new Controller(options)
}

module.exports = EditNewUser



// WEBPACK FOOTER //
// ./js/modules/client-users/edit_new/index.js